<div class="month-card rounded-sm">
  <div class="header">
    <div class="month-label">
      {{ monthLabel }} <i class="pi pi-question-circle clickable" (click)="monthInfoModalShown = true"></i>
    </div>
    @if (fosModalShown && cardData) {
    <app-hi-record-modal [record]="cardData.raw" [title]="recordType" [(visible)]="fosModalShown" />
    } @if (monthInfoModalShown) {
    <app-month-info-modal [(visible)]="monthInfoModalShown" [infoType]="recordType" />
    } @if (cardData.source) {
    <app-status-badge [status]="cardData.source" />
    } @else {
    <app-status-badge [status]="loadingStatus" />
    }
  </div>
  <div class="body">
    <div class="proj-container rounded">
      <div class="proj-label">PROJ</div>
      <div class="label-value col">
        @if (!cardData.raw) {
        <p-skeleton width="3rem" height="1rem" />
        } @else {
        <div
          [ngClass]="{
            pending: cardData.hiProj === 0,
            value: cardData.hiProj !== 0
          }"
        >
          {{ cardData.hiProj ? (cardData.hiProj | minutesToTime) : "PENDING" }}
        </div>
        }
        <div class="clickable label" (click)="fosModalShown = true">{{ recordType }}</div>
      </div>
      <div class="vertical-divider"></div>
      <div class="label-value col">
        @if (!cardData.planProj) {
        <p-skeleton width="3rem" height="1rem" />
        } @else {
        <div class="value">{{ cardData.planProj | minutesToTime }}</div>
        }
        <div class="label">Plan</div>
      </div>
    </div>
    <div class="details-container">
      <div class="label-value">
        <div class="label">PPROJ</div>
        @if (!cardData.raw) {
        <p-skeleton width="3rem" height="1rem" />
        } @else {
        <div
          [ngClass]="{
            pending: cardData.payProj === 0,
            value: cardData.payProj !== 0
          }"
        >
          {{ cardData.payProj ? (cardData.payProj | minutesToTime) : "PNDG" }}
        </div>
        }
      </div>
      <div class="label-value">
        <div class="label">VMAX</div>
        @if (!cardData.vmax) {
        <p-skeleton width="3rem" height="1rem" />
        } @else {
        <div class="value">{{ cardData.vmax | minutesToTime }}</div>
        }
      </div>
      <div class="label-value">
        <div class="label">IMAX</div>
        @if (!cardData.imax) {
        <p-skeleton width="3rem" height="1rem" />
        } @else {
        <div class="value">{{ cardData.imax | minutesToTime }}</div>
        }
      </div>
    </div>
  </div>
</div>
